import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/mmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/mmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/mmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/mmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/mmain/${Id}`);
  },
};
